/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/accessible-emoji */
import React from 'react';
import {
  Item,
  Header,
  Title,
  Picture,
  Image,
  Section,
  Footer,
  Divider,
  Paragraph,
  Link,
  BodySection,
  SmallDescription,
  Description,
  ButtonOutline,
  ButtonFill,
} from './style';

import { useLanguageContext } from '../../../../contexts/LanguageContext';
import { createSafeHtml } from '../../../../utils/sanitizeHtml';

const FinancingSolution = ({ theme, financingSolution }) => {
  const {
    title,
    subtitle,
    imageUrl,
    description,
    smallDescription,
    body,
    viewOffers,
    icon,
    buttonLink,
    learnMore,
    applyLink
  } = financingSolution;
  const { language } = useLanguageContext();
  return (
    <Item 
      theme={theme} 
      id={title} 
      className={`${language.locale.toLowerCase() === 'en-us' ? '' : 'skip-nav-focus'}`}
      tabIndex={`${language.locale.toLowerCase() === 'en-us' ? -1 : 0}`}>
      <Section flexBasis="50%">
        <Header>
          <Title>{title}</Title>
          <Paragraph small flex flexStart>
            <span className="dds__icons">{icon}</span>
            {' '}
            <span dangerouslySetInnerHTML={createSafeHtml(subtitle)} />
          </Paragraph>
        </Header>
        <Picture>
          <Image alt="" src={imageUrl ? imageUrl : ''} />
        </Picture>
      </Section>
      {description || smallDescription ? (
        <>
          <Section flexBasis="50%">
            <Description dangerouslySetInnerHTML={createSafeHtml(description)} />
            <SmallDescription dangerouslySetInnerHTML={createSafeHtml(smallDescription)} />
            {viewOffers && viewOffers.title && viewOffers.url ? (
              <Footer>
                <ButtonOutline 
                  target={viewOffers.newWindow ? "_blank" : "_self"}
                  href={viewOffers.url}
                  role="link"
                >
                  {viewOffers.title}
                </ButtonOutline>
              </Footer>
            ) : null}
          </Section>
          <Divider />
        </>
      ) : null}
      {body ? (
        <Section flexBasis="100%">
          <BodySection dangerouslySetInnerHTML={createSafeHtml(body)} />
          <Footer 
            center 
            buttonMarginRight={(applyLink && applyLink.url && applyLink.title) || (learnMore && learnMore.url && learnMore.title) ? true : false}
          >
            {buttonLink && buttonLink.url && buttonLink.title ? (
              <ButtonFill
                target={buttonLink.newWindow ? "_blank" : "_self"}
                href={buttonLink.url}
                role="link"
              >
                {buttonLink.title}
              </ButtonFill>
            ) : null}
            {applyLink && applyLink.url && applyLink.title ? (
              <Link 
                target={applyLink.newWindow ? "_blank" : "_self"}
                href={applyLink.url} 
                marginRight={learnMore && learnMore.url && learnMore.title ? true : false}
                marginTop 
              >
                {applyLink.title}
              </Link>
            ) : null}
            {learnMore && learnMore.url && learnMore.title ? (
              <Link 
                target={learnMore.newWindow ? "_blank" : "_self"}
                href={learnMore.url} 
                marginTop 
              >
                <u>{learnMore.title}</u>
              </Link>
            ) : null}
          </Footer>
        </Section>
      ) : null}
    </Item>
  );
};

export default FinancingSolution;
